import { useMapElement } from '../contextProviders/MapElementProvider';
import OutcomeDetails from '../common/OutcomeDetails';
import ApprovalConfiguration from './ApprovalConfiguration';
import screens from '../common/screens';

const ApprovalRouter = () => {
    const {
        currentScreen,
        mapElement,
        selectedOutcomeIndex,
        setSelectedOutcomeIndex,
        onSwitchScreen,
    } = useMapElement();

    switch (currentScreen) {
        case screens.approval:
            return <ApprovalConfiguration />;
        case screens.outcome: {
            // When adding a new outcome, selectedOutcomeIndex is null. In that case,
            // pass null to OutcomeDetails so it can auto-assign Approve/Deny correctly.
            const selectedOutcome =
                selectedOutcomeIndex == null
                    ? null
                    : (mapElement.outcomes?.[selectedOutcomeIndex] ?? null);

            return (
                <OutcomeDetails
                    outcome={selectedOutcome}
                    onSave={() => onSwitchScreen(screens.approval)}
                    onCancel={() => {
                        onSwitchScreen(screens.approval);
                        setSelectedOutcomeIndex(null);
                    }}
                />
            );
        }
        default:
            return null;
    }
};

export default ApprovalRouter;
